// Function to validate email format
function validateEmail(email) {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailPattern.test(email);
}

// Function to handle newsletter button click
function handleNewsletterButtonClick(event) {
  const emailInput = document.getElementById('custom-newsletter');
  const emailError = document.getElementById('email-error');

  if (!validateEmail(emailInput.value)) {
    emailError.style.display = 'block';
    event.preventDefault();
  } else {
    emailError.style.display = 'none';
  }
}

// Function to manage newsletter display based on URL parameters
function manageNewsletterDisplay() {
  const newsletterContainer = document.querySelector('.custom-newsletter-info');
  const newsletterThankyou = document.querySelector('.custom-newsletter-info-thankyou');
  const newsletterSubscribed = document.querySelector('.custom-newsletter-info-subscribed');
  const currentURL = window.location.href;

  if (currentURL.includes("customer_posted=true")) {
    toggleNewsletterVisibility(newsletterThankyou, newsletterContainer, newsletterSubscribed);
  } else if (currentURL.includes("form_type=customer")) {
    toggleNewsletterVisibility(newsletterSubscribed, newsletterContainer, newsletterThankyou);
  } else {
    toggleNewsletterVisibility(newsletterContainer, newsletterSubscribed, newsletterThankyou);
  }
}

// Helper function to toggle visibility of newsletter sections
function toggleNewsletterVisibility(showElement, hideElement1, hideElement2) {
  showElement.classList.remove('hidden');
  hideElement1.classList.add('hidden');
  hideElement2.classList.add('hidden');
}

// Event listeners for DOMContentLoaded and button click
window.addEventListener('DOMContentLoaded', manageNewsletterDisplay);
document.querySelector('.custom-newsletter-button').addEventListener('click', handleNewsletterButtonClick);


document.addEventListener("DOMContentLoaded", function () {
  manageNewsletterDisplay(); // still needed

  const newsletterSubmitButton = document.querySelector(".custom-newsletter-button");
  const newsletterForm = document.querySelector(".custom-newsletter-info #contact_form");
  const consentError = document.getElementById("consent-error");
  const emailInput = document.getElementById("custom-newsletter");
  const emailError = document.getElementById("email-error");

  if (newsletterSubmitButton) {
    newsletterSubmitButton.addEventListener("click", function (event) {
      event.preventDefault(); // always stop default first

      const newsletterEmail = emailInput.value.trim();
      const checkConsent = document.querySelector("#consent")?.checked;

      // Validate email
      if (!validateEmail(newsletterEmail)) {
        emailError.style.display = "block";
        return;
      } else {
        emailError.style.display = "none";
      }

      // Validate consent checkbox
      if (!checkConsent) {
        consentError.style.display = "block";
        return;
      } else {
        consentError.style.display = "none";
      }

      // Prepare data
      const header_value = {
        isoLanguage: "EN",
        isoCountry: "IN",
        brandCode: "BH0992",
        campaignId: "PN002385",
        campaignDescription: "Always On",
        origin: "https://www.simpleskincare.in/",
        formType: "signUp",
        entity: "PRM2.6",
      };

      const x_api_key = "b2930cbc-ae89-41f5-ad6a-32491386660d";

      const consumerIdentity = {
        firstName: "N/A",
        lastName: "N/A",
      };

      const contactDetail = {
        email: newsletterEmail,
      };

      const optInStatus = {
        legalAgeConsent: checkConsent,
        unileverEmailConsent: checkConsent,
        unileverSMSConsent: checkConsent,
      };

      const data_value = JSON.stringify({
        profile: {
          header: header_value,
          consumerIdentity,
          contactDetail,
          optInStatus,
        },
      });

      console.log("Sending Payload:", data_value);

      // Send API request
      fetch("https://forms-sg.unileversolutions.com/v3", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": x_api_key,
        },
        body: data_value,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          console.log("API Success:", data);
          newsletterForm.submit(); // only submit after all validation and API success
        })
        .catch((error) => {
          console.error("API Error:", error);
          // Submit form anyway on API failure
          newsletterForm.submit();
        });
    });
  }
});

// Email validation function
function validateEmail(email) {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailPattern.test(email);
}